import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { useLang } from '../context/LanguageContext';

export default function Stats() {
  const { t } = useLang();
  const stats = t.stats;

  return (
    <Box sx={{ background: '#111111', py: { xs: 4, md: 6 } }}>
      <Container maxWidth="xl">
        <Grid container>
          {stats.map((stat, i) => (
            <Grid item xs={6} md={3} key={stat.label}>
              <Box
                sx={{
                  textAlign: 'center',
                  py: { xs: 2.5, md: 3 },
                  px: { xs: 1, md: 2 },
                  borderRight: {
                    xs: i % 2 === 0 ? '1px solid rgba(255,255,255,0.08)' : 'none',
                    md: i < 3 ? '1px solid rgba(255,255,255,0.08)' : 'none',
                  },
                  borderBottom: {
                    xs: i < 2 ? '1px solid rgba(255,255,255,0.08)' : 'none',
                    md: 'none',
                  },
                }}
              >
                <Typography sx={{
                  fontFamily: '"Oswald", sans-serif',
                  fontSize: { xs: '2.4rem', sm: '2.8rem', md: '3.5rem' },
                  fontWeight: 700,
                  color: '#C8102E',
                  lineHeight: 1,
                  mb: 0.5,
                }}>
                  {stat.value}
                </Typography>
                <Typography sx={{
                  color: '#888888',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  fontSize: { xs: '0.62rem', md: '0.72rem' },
                  fontWeight: 500,
                }}>
                  {stat.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
